var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1155 9.75022L18.1609 11.2125L21.1155 12.6748L18.0847 14.1748L21.1155 15.6748L12 20.1863L2.88458 15.6748L5.91535 14.1748L2.88458 12.6748L5.8392 11.2125L2.88458 9.75022L12 5.23877L21.1155 9.75022ZM7.60618 15.0117L6.26623 15.6748L12 18.5126L17.7338 15.6748L16.3939 15.0117L12 17.1863L7.60618 15.0117ZM12 14.2617L16.47 12.0494L17.7338 12.6748L12 15.5126L6.26623 12.6748L7.53002 12.0494L12 14.2617ZM12 6.91243L6.26623 9.75022L12 12.588L17.7338 9.75022L12 6.91243Z",
    fill: "#ffffff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.89d3cfa0839168549ec9d07e9c2dd39c.svg";
export { ForwardRef as ReactComponent };